export default __webpack_public_path__ + "static/media/rd2.a5e87368.png";